export enum EState {
  view,
  detail,
  edit,
  project,
  activities,
}

export abstract class SidebarCommon<T> {
  public selected: T;
  public state: EState = EState.edit;

  public sideBarShow: boolean = false;
  public sideBarOpen: boolean = false;
  public sideBarAnimate: boolean = false;

  public get showEdit() {
    return this.state === EState.edit;
  }
  public get showView() {
    return this.state === EState.view;
  }
  public get showDetail() {
    return this.state === EState.detail;
  }
  public get showProject() {
    return this.state === EState.project;
  }
  public get showActivities() {
    return this.state === EState.activities;
  }

  constructor() {
    this.selected = {} as T;
    setTimeout(() => {
      this.sideBarAnimate = true;
    }, 200);
  }


  public create() {
    this.state = EState.edit;
    this.selected = {} as T;
    this.showSidebar();
    this.selected = {} as T;
  }

  public select(model: T) {
    if (this.selected === model && !this.sideBarOpen) this.selected = null;
    else {
      this.selected = model;
    }
  }

  public toggleSidebarDetail(item: T) {
    this.state = EState.detail;
    if (this.sideBarOpen) this.hideSidebar();
    else this.showSidebar();
    setTimeout(() => {
      this.selected = item;
    });
  }


  public toggleSidebarView(item: T) {
    this.state = EState.view;
    if (this.sideBarOpen) this.hideSidebar();
    else this.showSidebar();
    setTimeout(() => {
      this.selected = item;
    });
  }

  public toggleSidebarProject(item) {
    this.state = EState.project;
    if (this.sideBarOpen) this.hideSidebar();
    else this.showSidebar();
    setTimeout(() => {
      this.selected = item;
    });
  }

  public toggleSidebarActivities(item: T) {
    this.state = EState.activities;
    if (this.sideBarOpen) this.hideSidebar();
    else this.showSidebar();
    setTimeout(() => {
      this.selected = item;
    });
  }


  public toggleSidebar(item: T) {
    this.state = EState.edit;
    if (this.sideBarOpen) this.hideSidebar();
    else this.showSidebar();
    setTimeout(() => {
      this.selected = item;
    });
  }

  public hideSidebar() {
    this.sideBarOpen = false;
    this.sideBarShow = false;
    // setTimeout(() => {
    //   console.log('hide sidebar timeout');
    //   this.sideBarShow = false;
    // }, 200);
  }

  public showSidebar() {
    this.sideBarShow = true;
    // setTimeout(() => {
      this.sideBarOpen = true;
    // });
  }

  public abstract save(item: T);

  public abstract cancel(item: T);
}
